import { render } from "./TbHeader.vue?vue&type=template&id=36c763b8&scoped=true"
import script from "./TbHeader.vue?vue&type=script&lang=js"
export * from "./TbHeader.vue?vue&type=script&lang=js"

import "./TbHeader.vue?vue&type=style&index=0&id=36c763b8&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c763b8"]])

export default __exports__